export default __webpack_public_path__ + "static/media/featured_area_scarborough.7e785f70.webp";